// extracted by css-extract-rspack-plugin
export default {"inlineAnnotation":"InlineAnnotation-module__inlineAnnotation__ww6B1"};